import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "info",
  "use": "info-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"info\"><g fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"6\" cy=\"6\" r=\"6\" fill=\"#7E8FA5\" /><path fill=\"#FFF\" d=\"M5 5h2v5H5zm0-3h2v2H5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol